import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router';

import DashboardsLayout from './Layout';

import Error from './components/Error';

export default function App() {
  return (
    <RouterProvider
      router={createBrowserRouter(
        createRoutesFromElements(
          <Route element={<Outlet />} errorElement={<Error />}>
            <Route path="/:slug?" element={<DashboardsLayout />} />
          </Route>,
        ),
      )}
    />
  );
}
